









import { FlowState } from "../shared/types/FlowState";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProcessFlowState extends Vue
{
	@Prop() state!: FlowState;

	data()
	{
		return {
			model: {
				state: FlowState.Start
			},
			FlowState: FlowState
		}
	}

	onClick(e: number)
	{
		(this as any).model.state = e as FlowState;

		this.$emit("stateChanged", (this as any).model.state);
	}
}
